// Campus photo for /colleges/new-york-university: CC BY 3.0, by Jean-Christophe BENOIST, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ANYC_-_Washington_Square_Park_-_Arch.jpg), checked 2026-09-30 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/new-york-university/; credited under the photo.
const photo = {
    "slug": "new-york-university",
    "alt": "Washington Square Arch in Washington Square Park, beside NYU's campus in New York",
    "src": "/colleges/new-york-university/campus-1600.webp",
    "srcSmall": "/colleges/new-york-university/campus-800.webp",
    "srcMid": "/colleges/new-york-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/new-york-university/og.jpg",
    "title": "NYC - Washington Square Park - Arch",
    "author": "Jean-Christophe BENOIST",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ANYC_-_Washington_Square_Park_-_Arch.jpg",
    "read": "2026-09-30"
};

export default photo;
